export const SCOPE_DESTROYED = '@@SCOPE_DESTROYED';

export default (initialState: $TSFixMe, handlers: $TSFixMe) =>
    (state = {}, { type, payload, meta = {} }: $TSFixMe) => {
        const { scope } = meta;

        if (type === SCOPE_DESTROYED) {
            // @ts-expect-error $TSFixMeError: Type 'any' cannot be used as an index type.
            const { [scope]: omittedState, ...other } = state;
            return { ...other };
        }

        const handler = handlers[type];

        if (!handler) {
            return state;
        }
        // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
        const scopedState = state[scope] || initialState;
        return {
            ...state,
            [scope]: handler(scopedState, payload),
        };
    };
